import { render, staticRenderFns } from "./ReportForm.vue?vue&type=template&id=6a46fb4c&scoped=true&"
import script from "./ReportForm.vue?vue&type=script&lang=ts&"
export * from "./ReportForm.vue?vue&type=script&lang=ts&"
import style0 from "./ReportForm.vue?vue&type=style&index=0&id=6a46fb4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a46fb4c",
  null
  
)

export default component.exports